import { Link } from "react-router-dom"
import { BsCurrencyBitcoin, BsDice1, BsDice6Fill } from "react-icons/bs";
import React, { useRef, useCallback, useEffect, useMemo } from 'react'
import './navbar.scss'
import { useAuth } from "../../AuthProvider";
import { useNavigate } from "react-router-dom";
function openNav() {

    if (window.innerWidth >= 599) {
        if (document.getElementById("mySidenav").style.width === undefined || document.getElementById("mySidenav").style.width === null || document.getElementById("mySidenav").style.width === "") {
            setTimeout(onA, 0);

            setTimeout(() => {
                document.getElementById("mySidenav").style.width = "39px";

            }, 1000);
        }
        else if (document.getElementById("mySidenav").style.width === "240px") {
            setTimeout(onA, 0);

            setTimeout(() => {
                document.getElementById("mySidenav").style.width = "39px";

            }, 1000);

        }
        else if (document.getElementById("mySidenav").style.width === "39px") {
            document.getElementById("mySidenav").style.width = "240px";

            setTimeout(onA, 1000);
        }
    } else {

        setTimeout(onA, 0);

        setTimeout(() => {
            document.getElementById("mySidenav").style.width = "100%";

        }, 1000);
        var button = document.getElementById("openSpan");

    }



}


function onB() {

}
function onA() {
    console.log("Here");
    const testElements = document.getElementsByClassName("linkSpan");
    Array.prototype.filter.call(
        testElements,
        (element) => {
            if (element.style.display === undefined || element.style.display === null || element.style.display === "") {
                element.style.display = "none";
            }
            else if (element.style.display === "inline") {
                element.style.display = "none";
            } else {
                element.style.display = "inline";
            }
        },
    );
}
/* Set the width of the side navigation to 0 */
function closeNav() {
    //document.getElementById("mySidenav").style.width = "39px";
    //document.getElementById("openSpan").style.display = "block";
    //document.getElementById("closeIcon").style.display = "none";
    document.getElementById("lnkapan2").style.display = "none";
}
export default function Navbar(props) {
    const navigate = useNavigate();
    const userContext = useAuth();
    const span2 = useRef(null);
    const link1 = useRef(null);
    const link2 = useRef(null);
    const link3 = useRef(null);
    const changeStyleWhenLinkCLicked = (ref1, ref2, ref3) => {
        ref1.current.style.fontWeight = 'bold';
        //ref2.current.style.fontWeight = '';
        //ref3?ref3.current.style.fontWeight='':'';
    }
    const opennavigation = () => {


        openNav();

    }
    useEffect(() => {
        if (window.innerWidth >= 599) {
            document.getElementById("openSpan").style.display = 'block';
        } else {
            document.getElementById("mySidenav").style.width = "100%";
        }

    }, []);
    return (

        <div id="mySidenav" className="sidenav smalldevicewrapper">

            <div id="openSpan" className="openSpan" style={{ fontSize: '30px', position: 'absolute', top: 10, display: 'block', paddingLeft: '3px' }} onClick={opennavigation} >&#9776;</div>

            <Link ref={link1} to="/" className="linkRoot" onClick={() => { navigate("/"); changeStyleWhenLinkCLicked(link1, link2, link3); }}><BsCurrencyBitcoin size={20} style={{ position: 'relative', bottom: -3 }} />  <div id="lnkapan1" className="linkSpan">Task +</div></Link>

        </div>
    )
}